var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrestonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 828.937 262.564",
    enableBackground: "new 0 0 828.937 262.564",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "#E2001A",
    width: 828.937,
    height: 262.564
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "117.806,176.275 117.806,103.431 86.154,103.431 86.154,86.065 172.926,86.065 172.926,103.431  140.607,103.431 140.607,176.275  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M268.965,102.283c0,5.326-0.892,20.216-2.671,23.247c-1.697,2.95-3.62,4.83-5.76,5.634 c1.131,0.23,2.747,1.396,4.853,3.505c2.141,2.339,3.334,5.654,3.577,9.948v31.659h-22.743v-27.747 c-0.044-3.378-0.71-5.657-2.003-6.843c-1.172-1.304-3.035-2.014-5.58-2.128h-33.593v36.718h-22.739v-90.21h71.916 c4.571,0,8.188,1.403,10.855,4.204c2.586,3.025,3.886,6.568,3.886,10.631V102.283z M205.046,123.053h36.932 c1.207,0,2.241-0.358,3.088-1.087c0.771-0.693,1.155-1.728,1.155-3.106v-15.429h-41.175V123.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M298.254,159.768h66.859v16.507h-71.735c-4.979,0-8.735-1.365-11.279-4.087 c-2.509-2.759-3.764-6.326-3.764-10.698v-59.207c0-4.828,2.101-8.779,6.308-11.846c3.924-2.917,9.012-4.372,15.277-4.372h65.193 v17.365h-66.859v19.622h59.703v16.505h-59.703V159.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M444.768,123.053c5.502,0.309,9.627,1.795,12.371,4.462c2.748,2.664,4.121,6.294,4.121,10.897v22.511 c0,4.904-2.119,8.737-6.368,11.498c-4.279,2.568-9.292,3.855-15.034,3.855h-65.368v-16.507h66.859v-20.211h-49.277 c-6.023-0.077-10.46-1.299-13.311-3.651c-2.852-2.361-4.271-6.24-4.271-11.644v-21.979c0-4.828,2.056-8.779,6.182-11.846 c4.041-2.91,9.139-4.372,15.286-4.372h58.697v17.365h-60.252v19.622H444.768z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "464.989,86.065 551.767,86.065 551.767,103.431 519.444,103.431 519.444,176.275 496.643,176.275  496.643,103.431 464.989,103.431  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M645.093,160.922c0,4.94-2.155,8.797-6.489,11.552c-4.281,2.529-9.252,3.802-14.916,3.802h-50.581 c-4.765,0-8.484-1.347-11.148-4.03c-2.428-2.643-3.64-6.226-3.64-10.755v-59.207c0-4.945,2.061-8.891,6.184-11.846 c3.881-2.917,8.975-4.372,15.281-4.372h50.456c4.533,0,8.188,1.48,10.977,4.429c2.586,2.724,3.877,6.189,3.877,10.406V160.922z  M581.052,159.768h41.312v-56.338h-41.312V159.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M719.917,103.431h-41.3v72.845h-22.735v-90.21h71.86c4.608,0,8.267,1.48,10.974,4.429 c2.625,2.8,3.942,6.225,3.942,10.29v75.491h-22.741V103.431z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Suoja-alue",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M643.101,247.689c0,4.718-2.058,8.398-6.192,11.025c-4.083,2.414-8.825,3.626-14.229,3.626h-48.259 c-4.548,0-8.099-1.283-10.639-3.847c-2.316-2.52-3.474-5.936-3.474-10.258v-56.491c0-4.715,1.967-8.482,5.901-11.301 c3.702-2.782,8.562-4.169,14.579-4.169h48.139c4.325,0,7.814,1.406,10.475,4.225c2.469,2.596,3.698,5.903,3.698,9.929V247.689z  M582.001,246.594h39.411v-53.752h-39.411V246.594z"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M643.101,71.416c0,4.714-2.058,8.394-6.192,11.024c-4.083,2.413-8.825,3.624-14.229,3.624h-48.259 c-4.548,0-8.099-1.285-10.639-3.845c-2.316-2.521-3.474-5.936-3.474-10.259v-56.49c0-4.717,1.967-8.483,5.901-11.303 C569.912,1.387,574.772,0,580.789,0h48.139c4.325,0,7.814,1.409,10.475,4.225c2.469,2.596,3.698,5.904,3.698,9.927V71.416z  M582.001,70.319h39.411V16.567h-39.411V70.319z"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M757.521,170.356c-4.715,0-8.394-2.062-11.025-6.195c-2.414-4.083-3.623-8.827-3.623-14.23v-48.256 c0-4.548,1.282-8.098,3.844-10.64c2.521-2.316,5.938-3.472,10.258-3.472h56.491c4.716,0,8.483,1.967,11.307,5.901 c2.778,3.702,4.165,8.562,4.165,14.579v48.139c0,4.324-1.41,7.812-4.227,10.474c-2.594,2.47-5.902,3.702-9.924,3.702H757.521z  M758.618,109.252v39.415h53.752v-39.415H758.618z"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M14.736,168.857c-4.714,0-8.395-2.059-11.025-6.19c-2.412-4.087-3.623-8.827-3.623-14.231v-48.259 c0-4.547,1.285-8.097,3.845-10.639c2.521-2.314,5.936-3.473,10.26-3.473h56.489c4.716,0,8.483,1.966,11.306,5.901 c2.78,3.702,4.167,8.562,4.167,14.579v48.138c0,4.326-1.409,7.815-4.226,10.472c-2.596,2.474-5.904,3.702-9.924,3.702H14.736z  M15.835,107.756v39.412h53.75v-39.412H15.835z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrestonLogo);
export default __webpack_public_path__ + "static/media/Treston_logo.e34930dab85593cb8bc9e32eea869d95.svg";
export { ForwardRef as ReactComponent };